import cx from 'classnames';
import {useCallback, useEffect, useState} from 'react';

import {Input, InputProps, Icon} from 'components';

import {FilesManagerModal} from '../FilesManagerModal';
import {FilesManagerProps} from '../types';

type Props = {
    fullWidth?: boolean;
    helperText?: string;
    inputProps?: InputProps;
    modalOpen?: boolean;
    filesManagerProps: FilesManagerProps;
    onFilePathSelect: (path: string) => void;
    onCloseModal?: () => void;
};

export const FilesManagerInput: React.FC<Props> = ({
    inputProps, modalOpen: modalOpenProp, onCloseModal: onCloseModalProp, filesManagerProps, onFilePathSelect, helperText, fullWidth = true
}: Props) => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const onCloseModal = useCallback((accept: boolean, filePath: string) => {
        setModalOpen(false);
        if (accept) {
            onFilePathSelect(filePath);
        }
        onCloseModalProp?.();
    }, [onFilePathSelect, onCloseModalProp]);

    useEffect(() => {
        setModalOpen(modalOpenProp);
    }, [modalOpenProp]);

    return (
        <div className={cx('tw-w-full', fullWidth)}>
            <div className='tw-relative'>
                <Input
                    name='vs-files-manager-input'
                    hasEndIcon
                    description={helperText}
                    {...inputProps}
                />
                {!inputProps?.disabled &&
                    <div className='tw-h-8 tw-bg-transparent tw-my-px tw-pl-1 tw-absolute tw-right-1 tw-top-4'>
                        <Icon
                            name='paper-clip'
                            button
                            size='sm'
                            className='tw-h-8'
                            onClick={() => setModalOpen(true)}
                        />
                    </div>}
            </div>
            <FilesManagerModal
                {...filesManagerProps}
                open={modalOpen}
                selectedFilePath={inputProps?.value as string}
                onClose={onCloseModal}
                onRemoveSelected={() => inputProps?.onChange('')}
            />
        </div>
    );
};